<div class="pickup-later">
    <div class="pickup-later__inner">
        <ng-template #optionTemplate let-item="item">
            <ng-container *ngIf="item.Id === -1">
                {{item.Name}} <shared-icon class="pickup-later__icon -next" icon="next"></shared-icon>
            </ng-container>
            <ng-container *ngIf="item.Id >= 0">
                {{item.Name}}
            </ng-container>
        </ng-template>
        <shared-drop-down (onToggle)="dropdownToggle($event)" (onSelected)="dropdownSelected($event)"
            [options]="options" [optionTemplate]="optionTemplate" [selected]="selected" position="br" [theme]="theme"
            [width]="dropdownWidth" [projection]="mode === 'filter' ? 'local' : 'global'">

            <button class="pickup-later__btn pickup-btn{{mode ? ' -mode-'+mode : ' -mode-filter' }}"
                [disabled]="disabled || !options || options.length === 0"
                [ngClass]="{'is-active': isActive, 'is-disabled': disabled}">
                <div class="pickup-later__label pickup-btn__label">
                    {{ selected || displayLabel | pickupLabel: labelType}}
                </div>

                <div class="pickup-later__icon pickup-btn__icon">
                    <shared-circle-btn [disabled]="disabled"
                        [feel]="mode === 'filter' ? 'light-accent' : 'brand-accent'"
                        [hoverShadow]="mode === 'filter' ? false : true" [icon]="isActive ? 'down' : 'next'">
                    </shared-circle-btn>
                </div>

            </button>

        </shared-drop-down>
    </div>
</div>
